import React from 'react'
import _ from 'lodash'
import { Card } from 'antd'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import './PatientCard.scss'

const fixContentUrl = (url) => (
  url
  ? `https://content.remeind.zugarzeeker.com/content?url=${url}`
  : 'https://assets17.sigaccess.org/images/user_icon.png'
);

export const PatientCard = ({ userInfo, loading }) => {
  const user = userInfo.user || userInfo.patient
  return (
    <Card className="card" loading={loading}>
      <div className="custom-image">
        <img width="100%" src={fixContentUrl(userInfo.displayImage)} />
      </div>
      <div className="custom-card">
        <h3>{loading ? 'กำลังโหลด...' : `${user.firstname} ${user.lastname}`}</h3>
        <p>ชื่อในไลน์: {userInfo.displayName}</p>
      </div>
    </Card>
  )
}

function mapStateToProps(state) {
  const {userInfo, loading} = state;
  return {userInfo, loading}
}

const getPatients = _.noop

function mapDispatchToProps(dispatch) {
  return {
    getPatients: bindActionCreators(getPatients, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/Card/PatientCard.js